export default "__VITE_ASSET__DI0TkF80__"